import React from 'react';

import NewSchemaModalLauncher from './NewSchemaModalLauncher';

export default function SchemasTableActions() {
  return <NewSchemaModalLauncher />;
}
